export default __webpack_public_path__ + "static/media/strokeCheck.0fa440c8.svg";